import { memo } from 'react';

import cls from './onboarding-step-counter.module.css';

interface OnboardingStepCounterProps {
    currentStep: number;
    totalSteps: number;
}

export const OnboardingStepCounter = memo(
    (props: OnboardingStepCounterProps) => {
        const { currentStep, totalSteps } = props;

        return (
            <div className={cls.stepCounter}>
                {currentStep}/{totalSteps}
            </div>
        );
    },
);

OnboardingStepCounter.displayName = 'OnboardingStepCounter';
